import { render, staticRenderFns } from "./home-accordion.vue?vue&type=template&id=760f09ba"
import script from "./home-accordion.vue?vue&type=script&lang=js"
export * from "./home-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports